import React, { useEffect, useState } from 'react';
import DiscussionCreateForm from './DiscussionCreateForm';
import DiscussionDetails from './DiscussionDetails';
import { getAxiosResponse, postAxiosResponse } from "../../../services/authApiRoutes/APImethods";
import DataTable, { createTheme } from "react-data-table-component";
import {useLocation, useNavigate, useParams } from "react-router-dom";
import Constants from "../../../Constants";
import APIUrls from "../../../services/APIUrls";
import { dateFormat, dateFormatAndStatus } from "../../../services/Util";
import $ from "jquery";
import Select from "react-select";
import { useSelector } from 'react-redux';
import { AttachmentIcon } from '../../../AppIcons';
import { ConditionalBlock } from "../../../ConditionalBlock";
import dateUtil from "../../../services/DateUtil";

export default function Discussion(prop) {

  const param = useParams();
  const projectId = param.id;
  const navigate = useNavigate();
  const[showCreate, toggleShowCreate] = useState(false);
  const[showDetails,toggleShowDetails] = useState(false);
  const [pending, setPending] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [topics,setTopics] = useState([]);
  const [topicId,setTopicId] = useState(null);
  const [selectedTopics,setSelectedTopics] = useState([]);
  const [displayFilter, toggleDisplayFilter] = useState(false);
  const [selectedUser,setSelectedUser] = useState("");
  const [selectedType,setSelectedType] = useState("");
  const [creatorUsers,setCreatorUsers] = useState([]);
  const [refreshPage,setRefreshPage] = useState(false);
  const tabId = param.tabId;
  const types = [
    { label: "ALL Discussions", value: Constants.ALL },
    { label: "Unread Discussions", value: Constants.UN_READ },
  ];
  const {state} = useLocation();
  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;
  useEffect(()=>{
    if(state !== null && state!== undefined){
      setTopicId(state?.topicId);
      toggleShowDetails(state?.showDetails);
    }
  },[state]);

  useEffect(()=>{
    if(tabId){
      showDetailsPage(false,tabId);
    }
  },[tabId])

  useEffect(()=>{
    if(prop.discussionsId!==""){
    setTopicId(prop.discussionsId);
    toggleShowDetails(true);
    }
  },[prop.discussionsId])

  useEffect(() => {
    toggleShowCreate(prop.isRedirect);
  }, [])

  useEffect(()=>{
    if(!showCreate && !showDetails){
      fetchDiscussion(currentPage);
      fetchPosters(currentPage);
    }
  },[currentPage,selectedType,selectedUser,refreshPage]);

  const toggleTopicList = (val) =>{
    toggleShowCreate(val);
    toggleShowDetails(val);
    setRefreshPage(refreshPage?false:true);
    setTimeout(() => {
       $('.bluebtnFocus').trigger('focus')
    }, 100);
  };

  const showDetailsPage = (val,topicId) =>{
    setTopicId(topicId);
    toggleShowCreate(val);
    toggleShowDetails(!val);
  };

  const fetchDiscussion = ()=>{
    setPending(true);
    getAxiosResponse(getUrlWithQueryParam(projectId))
    .then((res) => {
      if(res.data.data){
        setTopics(res.data.data);
      }

    }).catch((err) => {
      console.error(err);
    })
  };

  const getUrlWithQueryParam = (projectId)=>{
    let type = selectedType?selectedType:Constants.ALL;
    let url = APIUrls.TOPIC_LIST(projectId,type);
    if(selectedUser){
      url = `${url}?${selectedUser}`;
    }
    return url;
  };

  const fetchPosters = ()=>{
    getAxiosResponse(APIUrls.TOPIC_POSTERS(projectId))
    .then((response)=>{
      if(response.data?.code === 200){
        const posters = response.data?.data;
        let data = [];
        data.push({label:"Anyone",value:""});
        posters.map((o)=>{
          if(o.organizationType === "CUSTOMER"){
            data.push({label:`${o.userFirstName} ${o.userLastName}`,value:`postedByUserId=${o.userId}`});
          }else {
            data.push({label:`${o.organizationName}`,value:`postedByOrganizationId=${o.organizationId}`});
          }
        });
        setCreatorUsers(data);
      }
    }).catch((err)=>{
      console.error(err);
    });
  }

  const markasread = ()=>{
    setPending(true);
    const data = {"ids":selectedTopics};
    postAxiosResponse(APIUrls.TOPIC_MARK_AS_READ,data)
    .then((response)=>{
      if(response.data?.code ===200){
        setSelectedTopics([]);
        disbaleMarkRead();
        setRefreshPage(refreshPage?false:true);
      }
    }).catch((err)=>{
      console.error(err);
    })
  };

  const disbaleMarkRead = ()=>{
    const btn = $("#mark-read");
    if(!btn.hasClass("disabled-data")){
      btn.addClass("disabled-data")
      btn.attr('disabled', 'disabled')
    }
  };

  const enableMarkRead = ()=>{
    const btn = $("#mark-read");
    if(btn.hasClass("disabled-data")){
      btn.removeClass("disabled-data")
      btn.removeAttr('disabled', 'disabled')
    }
  };

  const handleChange = ({ selectedRows })=>{
    const ids = selectedRows.map((o)=>{
      return o.id;
    });
    if(ids.length>0){
      enableMarkRead();
    }else{
      disbaleMarkRead();
    }
    setSelectedTopics(ids);
  };

  const filterToggle = () => {
    displayFilter ? toggleDisplayFilter(false) : toggleDisplayFilter(true);
    $('#activeId').toggleClass('clickActive')
    $(document).mouseup(function(e) {
      var bannerCont = $('.btn-wrap');
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        toggleDisplayFilter(false);
        $(".clickActive").trigger("focus");
        $('#activeId').removeClass('clickActive')
      }
    });
  };

  const handleEscFocus = (event) => {
    if (event.key === Constants.ESCAPE && event.target.ariaExpanded === 'true') {
      toggleDisplayFilter(false);
      $("#activeId").trigger("focus");
      $('#activeId').removeClass('clickActive')
    }
  };

  const handleModalFocus = (event) => {
    if (event.key === Constants.ESCAPE && event.target.ariaExpanded === 'false') {
      toggleDisplayFilter(false);
      $("#activeId").trigger("focus");
      $('#activeId').removeClass('clickActive')
    }
    if (event.target.ariaLabel === 'Posted By') {
      if (event.key === Constants.TAB && !event.shiftKey) {
        event.preventDefault();
        toggleDisplayFilter(false);
        $("#activeId").trigger("focus");
      }
    }
    if (event.target.ariaLabel === 'View By') {
      if (event.key === Constants.TAB && event.shiftKey) {
        event.preventDefault();
        toggleDisplayFilter(false);
        $("#activeId").trigger("focus");
      }
    }
  };

  useEffect(() => {
    if (displayFilter ) {
      $(".local-filter").css("display", "block");
      $("#activeId").attr("aria-expanded", "true");
     } else {
      $(".local-filter").css("display", "none");
      $("#activeId").attr("aria-expanded", "false");
    }
  }, [displayFilter]);

  const handleSort = async (column, sortDirection) => {
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
      .attr({ 'aria-label': column.name, 'aria-sort': sortDirection.toUpperCase() === Constants.DESC  ? Constants.DESCENDING : Constants.ASCENDING });
  };

  $(document).ready(function(){
    $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true"); 
    $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
    $(".rdt_Table").attr("aria-label","Discussions"); 
    $('.rdt_Table input').parent().attr("role","cell")
   })
   const redirectChatwindow = (e, row) =>{
    if (e.key === Constants.ENTER) {
       navigate(`/project/${projectId}/discussions/${row.id}`);
    }
  }
  const handleTypeChange=(e)=>{
    let selectedType = e.value;
    setSelectedType(selectedType);
  };

  const handleCreatorChange=(e)=>{
    let selectedUser = e.value;
    setSelectedUser(selectedUser);
  }

  const TitleComponent = ({ row })=>{
    return (
      <>
        {row.hasUnreadMessages?
          <div className='inline-flex unread-msg-icon'>
            <svg xmlns="http://www.w3.org/2000/svg" width="17px" height="17px" viewBox="0 0 48 48" fill="none">
              <rect width="48" height="48" fill="white" fillOpacity="0.01"/>
              <path d="M44 16V36H29L24 41L19 36H4V6H34" stroke="#1D4ED8" strokeWidth="4" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M23 20H25.0025" stroke="#1D4ED8" strokeWidth="4" stroke-linecap="round"/>
              <path d="M33.0011 20H35" stroke="#1D4ED8" strokeWidth="4" stroke-linecap="round"/>
              <path d="M13.001 20H14.9999" stroke="#1D4ED8" strokeWidth="4" stroke-linecap="round"/>
              <circle cx="43" cy="7" r="3" fill="#1D4ED8"/>
            </svg>
          </div>
        :Constants.BLANK}
        <a onClick={()=> {
            setTopicId(row.id);
            toggleShowDetails(true);
            if (row.hasUnreadMessages) {
              prop.decreaseMessageCount();
            }
          }}
          tabIndex="0"
          onKeyDown={(e)=> redirectChatwindow(e, row)}>
          {row.subject}
        </a>
        <ConditionalBlock condition={row?.hasMessageAttachment}>
          <span className='attachment-icon'>
            {AttachmentIcon}
          </span>
        </ConditionalBlock>
      </>
    )
  }

  const caseInsensitiveSort = (rowA, rowB) => {
    const a = rowA.subject.toLowerCase();
    const b = rowB.subject.toLowerCase();
    if (a > b) {
        return 1;
    }
    if (b > a) {
        return -1;
    }
    return 0;
  };

  const columns = [
      {
        id: "subject",
        name: "Title",
        minWidth: "350px",
        sortable: true,
        sortFunction:caseInsensitiveSort,
        cell: (row) => <TitleComponent row={row} />
      },
      {
        id: "entityType",
        name: "Type",
        minWidth: "350px",
        sortable: false,
        cell: (row) => row.entityType
      },
      {
        id: "createdDate",
        name: "Date",
        minWidth: "350px",
        sortable: false,
        cell: (row, date) =>
                  row.createdDate !== "" ? (
                    date = dateUtil.format(row.createdDate),
                    <div className='relative'>
                      <span aria-label={date} className='font-zero setFastpass'>{date}</span>
                      <span aria-hidden="true">{date}</span>
                    </div>
                  ) : ("")
      }
  ];

  const noDataFoundComponent = () => {
    return (
      <div className="no-data-display align-center">
        <i className="nodata-icon"></i>
        <p>{Constants.NO_DATA_FOUND}</p>
      </div>
    );
  };

  return (
    <div className='project-task change-order-page discussion-page'>
        {showCreate ? <DiscussionCreateForm id={projectId} toggleTopicList = {toggleTopicList} showDetailsPage = {showDetailsPage}/> :
          (showDetails ? <DiscussionDetails id={projectId} topicId = {topicId} toggleTopicList = {toggleTopicList}/> :
            <div className="listing-content relative">
                        <div className="campaign_details-task campaign-form">
                            <div className="projects-heading">
                              <h5>Discussions</h5>
                              <div className="btn-wrap">
                              <button disabled id="mark-read" className="btn-bold disabled-data" onClick={markasread}>Mark as read</button>
                                <div className="filter" id="filter">
                                    <button id="activeId" className="dashboard-btn filterTask" onClick={filterToggle}
                                    aria-expanded="false"
                                    onKeyDown={(e) => handleEscFocus(e)}
                                    >
                                      <span className="filter-icon">
                                      <svg
                                        width="19"
                                        height="14"
                                        viewBox="0 0 19 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M18.5627 4.00922H7.56233C7.32684 4.00922 7.125 3.64384 7.125 3.21755C7.125 2.79127 7.32684 2.42589 7.56233 2.42589H18.5627C18.7982 2.42589 19 2.79127 19 3.21755C19 3.64384 18.7982 4.00922 18.5627 4.00922Z"
                                          fill="#1D4ED8"
                                        ></path>
                                        <path
                                          d="M2.99075 3.649H0.607496C0.280383 3.649 0 3.36861 0 3.0415C0 2.71439 0.280383 2.43401 0.607496 2.43401H2.99075C3.31786 2.43401 3.59824 2.71439 3.59824 3.0415C3.59824 3.36861 3.36459 3.649 2.99075 3.649Z"
                                          fill="#1D4ED8"
                                        ></path>
                                        <path
                                          d="M5.37429 6.03238C3.73873 6.03238 2.38354 4.6772 2.38354 3.04164C2.38354 1.40607 3.73873 0.0508881 5.37429 0.0508881C7.00986 0.0508881 8.36504 1.40607 8.36504 3.04164C8.36504 4.6772 7.05659 6.03238 5.37429 6.03238ZM5.37429 1.26588C4.39295 1.26588 3.59854 2.0603 3.59854 3.04164C3.59854 4.02298 4.39295 4.81739 5.37429 4.81739C6.35563 4.81739 7.15005 4.02298 7.15005 3.04164C7.15005 2.0603 6.35563 1.26588 5.37429 1.26588Z"
                                          fill="#1D4ED8"
                                        ></path>
                                        <path
                                          d="M0.437329 9.9906L11.4377 9.9906C11.6732 9.9906 11.875 10.356 11.875 10.7823C11.875 11.2085 11.6732 11.5739 11.4377 11.5739L0.437329 11.5739C0.201844 11.5739 -3.19429e-08 11.2085 -6.92097e-08 10.7823C-1.06476e-07 10.356 0.201844 9.9906 0.437329 9.9906Z"
                                          fill="#1D4ED8"
                                        ></path>
                                        <path
                                          d="M16.0093 10.3508L18.3925 10.3508C18.7196 10.3508 19 10.6312 19 10.9583C19 11.2854 18.7196 11.5658 18.3925 11.5658L16.0093 11.5658C15.6821 11.5658 15.4018 11.2854 15.4018 10.9583C15.4018 10.6312 15.6354 10.3508 16.0093 10.3508Z"
                                          fill="#1D4ED8"
                                        ></path>
                                        <path
                                          d="M13.6257 7.96743C15.2613 7.96743 16.6165 9.32262 16.6165 10.9582C16.6165 12.5937 15.2613 13.9489 13.6257 13.9489C11.9901 13.9489 10.635 12.5937 10.635 10.9582C10.635 9.32262 11.9434 7.96743 13.6257 7.96743ZM13.6257 12.7339C14.607 12.7339 15.4015 11.9395 15.4015 10.9582C15.4015 9.97684 14.607 9.18242 13.6257 9.18242C12.6444 9.18242 11.8499 9.97684 11.85 10.9582C11.85 11.9395 12.6444 12.7339 13.6257 12.7339Z"
                                          fill="#1D4ED8"
                                        ></path>
                                      </svg>
                                      </span>{" "}
                                      Filters
                                    </button>
                                    <div id="filterBtn" className="filter-content flex pb-5 local-filter"
                                    onKeyDown={(e) => handleModalFocus(e)}
                                    >
                                      <div className="flex wrap-dropdown">
                                        <div className="global-dropdown-block mar-bot20">
                                          <label className='justify-start mar-bot6'>View By</label>
                                          <Select classNamePrefix='cw'
                                            className="global-dropdown-select"
                                            value={types.filter(function (option) {
                                              return option.value === selectedType;
                                            })}
                                            aria-label="View By"
                                            options={types}
                                            onChange={(e) => handleTypeChange(e)}/>
                                        </div>
                                        <div className="global-dropdown-block mar-bot20">
                                          <label className='justify-start mar-bot6'>Posted By</label>
                                          <Select classNamePrefix='cw'
                                            className="global-dropdown-select"
                                            value={creatorUsers.filter(function (option) {
                                              return option.value === selectedUser;
                                            })}
                                            aria-label="Posted By"
                                            options={creatorUsers}
                                            onChange={(e) => handleCreatorChange(e)}/>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                                
                                <button className="blue-btn bluebtnFocus active" onClick={()=>toggleShowCreate(true)}>Start New Discussion</button>
                              </div>
                            </div>
                            <div className="discussion-content">
                             
                              <div className="datatable-block">
                              <DataTable
                                keyField="id"
                                columns={columns}
                                onSort={handleSort}
                                data={topics}
                                defaultSortFieldId={1}
                                responsive
                                striped
                                selectableRows
                                onSelectedRowsChange={handleChange}
                                noDataComponent={noDataFoundComponent()}
                              />
                              </div>
                            </div>
                          </div>
            </div>  
          )
        }          
    </div>
  );
}
